import { FC } from "react";
import { styled } from "@mui/system";
import Table from "@mui/material/Table";
import { TableContainer } from "@mui/material";

interface Prop {
  tableBg?: string;
  tHeadBg?: string;
  children?: any;
  tableSize?: string;
  tableBorder?: boolean;
  oddCellBg?: boolean;
  evenCellBg?: boolean;
  oddCellColor?: string;
  evenCellColor?: string;
  tHeadTextColor?: string;
  tBodyTextColor?: string;
}

const GullTable: FC<Prop> = (props) => {
  const {
    tableBg,
    tHeadBg,
    tableSize,
    children,
    tableBorder,
    oddCellBg,
    evenCellBg,
    oddCellColor,
    evenCellColor,
    tHeadTextColor,
    tBodyTextColor,
  } = props;

  const StyledTable = styled(Table)(({ theme }) => ({
    background: tableBg ? tableBg : "none",
    "& th, td": {
      padding:
        tableSize === "small"
          ? ".3rem"
          : tableSize === "large"
          ? "1rem"
          : ".75rem",
      borderTop: `1px solid ${tableBg ? "#5B5164" : theme.palette.grey[300]}`,
      border: tableBorder
        ? `1px solid ${tableBg ? "#5B5164" : theme.palette.grey[300]}`
        : tableBorder === false && "none",
    },
    "& th": {
      fontWeight: "bold",
      color: tHeadTextColor || theme.palette.grey[800],
      background: tHeadBg ? tHeadBg : "none",
      borderBottom: `.1rem solid ${
        tableBg || tHeadBg ? "#5B5164" : theme.palette.grey[300]
      }`,
    },
    "& td": {
      borderBottom: "none",
      color: tBodyTextColor || theme.palette.grey[800],
    },
    "& #GullTableRow": {
      "&:nth-of-type(odd)": {
        backgroundColor: oddCellBg ? oddCellColor || "#8e8e8e1c" : "none",
      },
      "&:nth-of-type(even)": {
        backgroundColor: evenCellBg ? evenCellColor || "transparent" : "none",
      },
      "&:last-child td, &:last-child th": {
        borderBottom: tableBorder
          ? `1px solid ${tableBg ? "#5B5164" : theme.palette.grey[300]}`
          : tableBorder === false && "none",
      },
    },
  }));

  return (
    <TableContainer>
      <StyledTable id="TableRoot">{children}</StyledTable>
    </TableContainer>
  );
};

export default GullTable;
